import {html, LitElement, PropertyValues, TemplateResult} from 'lit';

import {customElement, property, query} from 'lit/decorators.js';
import {Liferay} from "../liferay.ts";

@customElement('cv-portlet-refresh')
export class PortletRefreshComponent extends LitElement {

    @property({type: Object})
    data: Record<string, unknown> = {};

    @query('section.portlet:first-of-type')
    _portlet!: HTMLInputElement;

    /* LitElement uses a shadow root by default. We want to render the template */
    createRenderRoot() {
        return this;
    }

    updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);
        if (changedProperties.has('data')) {

            if (!this._portlet) {
                console.error('portlet not found in ' + this);
                return;
            }

            let portletElement: HTMLElement | null = this._portlet;
            while (portletElement && !portletElement.classList.contains('portlet-boundary')) {
                portletElement = portletElement.parentElement;
            }
            if (!portletElement) {
                console.error('portlet-boundary not found for ' + this._portlet);
                return;
            }

            if (!this._portlet.id.startsWith('portlet_')){
                console.error('portlet id does not start with portlet_ ' + this._portlet.id);
                return;
            }

            const portletId = this._portlet.id.replace('portlet_', '');

            const _data = Liferay.Util.ns(Liferay.Util.getPortletNamespace(portletId), this.data || {});
            Liferay.Portlet.refresh(portletElement, _data);
        }
    }

    render(): TemplateResult {
        return html``;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'cv-portlet-refresh': PortletRefreshComponent;
    }
}
